import React, { useState } from 'react';
import { Drawer } from '../Drawer';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { colorPalette } from '../../../colorPalette';
import { styled } from '@mui/material';
const StyledLink = styled('a')({
    textDecoration: 'underline',
    color: colorPalette.gray700,
    fontWeight: 400,
});
export const DrawerLoiLemareMob = () => {
    const [open, setOpen] = useState(false);
    return (React.createElement(Stack, null,
        React.createElement(Drawer, { open: open, onClose: () => {
                setOpen(false);
            }, title: "Garanties applicables", PaperProps: {
                sx: {
                    maxHeight: '45vh',
                },
            }, showHeader: true, content: React.createElement(Typography, { component: "p", sx: {
                    padding: '16px',
                    color: colorPalette.gray700,
                    fontWeight: 400,
                    fontSize: '14px',
                } },
                "Tous les achats \u00E9ligibles \u00E0 la",
                ' ',
                React.createElement(StyledLink, { href: "https://help.fr.shopping.rakuten.net/hc/fr/articles/10324490666002-A-quoi-correspondent-les-frais-de-protection-acheteur-pr%C3%A9lev%C3%A9s-lors-de-mon-achat", target: "_blank" }, "protection acheteurs"),
                ' ',
                "b\u00E9n\u00E9ficient de l\u2019avantage \u201CSatisfait ou rembours\u00E9\u201D. Toutefois, le droit de r\u00E9tractation au sens de l\u2019article L.221-18 et la garantie l\u00E9gale de conformit\u00E9 vis\u00E9e aux articles L.217-3 et suivants du Code de la consommation ne sont pas applicables pour cet achat r\u00E9alis\u00E9 aupr\u00E8s d\u2019un vendeur particulier. La garantie l\u00E9gale des vices cach\u00E9s vis\u00E9e aux articles 1641 \u00E0 1649 du Code civil reste applicable. En savoir plus sur les dispositions l\u00E9gales relatives au",
                ' ',
                React.createElement(StyledLink, { href: "https://www.legifrance.gouv.fr/codes/section_lc/LEGITEXT000006070721/LEGISCTA000032006712/#LEGISCTA000032006712", target: "_blank" }, "droit des obligations"),
                ' ',
                "et de la",
                ' ',
                React.createElement(StyledLink, { href: "https://www.legifrance.gouv.fr/codes/id/LEGISCTA000032009929", target: "_blank" }, "responsabilit\u00E9 civile"),
                ".") }),
        React.createElement(Stack, { component: "div", direction: "row", justifyContent: "space-between", alignItems: "center", onClick: () => {
                setOpen(true);
            } },
            React.createElement(Typography, { sx: {
                    fontSize: '14px',
                    fontWeight: 400,
                    color: colorPalette.gray700,
                } }, "En savoir plus sur les garanties applicables"),
            React.createElement(ChevronRightIcon, { sx: {
                    color: colorPalette.gray700,
                    height: 24,
                    width: 24,
                } }))));
};
